"use client";
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
      // Increase timeout for long-running operations like checkout with accounting integration
      networkMode: "always", // Don't pause mutations even if offline
    },
  },
});
